/**
 *  @class
 *  @function CountdownTimer
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split('-'),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour = 0,
        tarmin = 0;

      if (time) {
        [tarhour, tarmin] = time.split(':').map(Number);
      }

      // Set the date we're counting down to
      let date_string = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' GMT' + timezone;
      // Time without timezone
      this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();

      // Time with timezone; the configured minute is inclusive — a timer set
      // to 23:59 runs until the minute is over (00:00:00), not until 23:59:00
      this.countDownDate = new Date(date_string).getTime() + 60000;

    }

    convertDateForIos(date) {
      var arr = date.split(/[- :]/);
      date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      return date;
    }
    connectedCallback() {

      const daysEl = this.querySelector('.days .countdown-timer--column--number'),
        hoursEl = this.querySelector('.hours .countdown-timer--column--number'),
        minutesEl = this.querySelector('.minutes .countdown-timer--column--number'),
        secondsEl = this.querySelector('.seconds .countdown-timer--column--number');
      // labels carry their singular form in data-singular; the plural is the
      // server-rendered text, remembered on first use
      const setLabel = (numberEl, value) => {
        const labelEl = numberEl.parentElement.querySelector('.countdown-timer--column--text');
        if (!labelEl || !labelEl.dataset.singular) return;
        if (!labelEl.dataset.plural) labelEl.dataset.plural = labelEl.textContent;
        labelEl.textContent = value === 1 ? labelEl.dataset.singular : labelEl.dataset.plural;
      };
      // renders the current remaining time; returns false once expired
      const updateTime = () => {
        // Get todays date and time
        const now = Date.now();

        // Find the distance between now an the count down date
        const distance = this.countDownDate - now;

        if (distance < 0) {
          daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
          [daysEl, hoursEl, minutesEl, secondsEl].forEach((el) => setLabel(el, 0));
          if (this.dataset.hideExpired) {
            this.classList.add('countdown-timer--expired');
          }
          // drop mode: the timer just hit zero — reveal the sections below
          // the banner (hidden via html.collection-drop-pending, see the
          // section's inline <style>) and fire a resize so lazyload and
          // sliders inside the previously hidden grid measure themselves
          if (this.dataset.hideContent && document.documentElement.classList.contains('collection-drop-pending')) {
            document.documentElement.classList.remove('collection-drop-pending');
            window.dispatchEvent(new Event('resize'));
          }
          return false;
        }

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = CountdownTimer.addZero(days);
        hoursEl.textContent = CountdownTimer.addZero(hours);
        minutesEl.textContent = CountdownTimer.addZero(minutes);
        secondsEl.textContent = CountdownTimer.addZero(seconds);

        setLabel(daysEl, days);
        setLabel(hoursEl, hours);
        setLabel(minutesEl, minutes);
        setLabel(secondsEl, seconds);

        return true;
      };
      // lazy ticking: the update loop only runs while the timer is in the
      // viewport; the remaining time is always derived from Date.now(), so
      // re-entering the viewport shows the correct value immediately
      const tick = () => {
        if (!this.isVisible) {
          return;
        }
        if (updateTime()) {
          this.raf = requestAnimationFrame(tick);
        }
      };
      updateTime();
      // the section renders the timer hidden (--pending) and an inline script
      // reveals it before first paint; that script does not re-run on theme
      // editor section re-renders, so clear the flag here as well
      this.classList.remove('countdown-timer--pending');
      // drop mode: same story for the html flag that hides the sections below
      // — the inline script sets it before first paint, this keeps it in sync
      // on re-renders (set while running, cleared once expired)
      if (this.dataset.hideContent) {
        const remaining = this.countDownDate - Date.now();
        document.documentElement.classList.toggle('collection-drop-pending', remaining > 0);
        // the tick loop below only runs while the timer is in the viewport;
        // the reveal must not depend on that, so schedule one update for the
        // exact end (setTimeout caps at ~24.8 days, longer timers rely on the loop)
        if (remaining > 0 && remaining < 2147483647) {
          setTimeout(updateTime, remaining + 50);
        }
      }
      this.isVisible = false;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.isVisible = entry.isIntersecting;
            cancelAnimationFrame(this.raf);
            if (entry.isIntersecting) {
              tick();
            }
          });
        });
        this.observer.observe(this);
      } else {
        this.isVisible = true;
        tick();
      }
    }
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      cancelAnimationFrame(this.raf);
    }
    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}